import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./EditProfile1.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import LogItem from "../../comm/global/components/LogItem";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
const EditProfile1 = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [text, set_text] = useState("");
    const [label, set_label] = useState("");
    const [btnLabel, set_btnLabel] = useState("");
    const [tip, set_tip] = useState("");
    const [limitLen, set_limitLen] = useState(50);
    const [h, set_h] = useState(0);

    const adjustButtonPosition = () => {
        const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        set_h(window.innerHeight - viewportHeight)
    };
    useEffect(() => {
        set_text(arg.value);
        switch (arg.type) {
            case "name":
                set_label("名稱");
                set_btnLabel("儲存")
                set_tip("60天內只能更動1次。請勿輸入數字與符號。");
                set_limitLen(20);
                break;
            case "ID":
                set_label("ID");
                set_btnLabel("儲存")
                set_tip("60天內只能更動1次。請輸入數字、英文、”.” 或 ”_”。");
                set_limitLen(20);
                break;
            case "mail":
                set_label("電子信箱");
                set_btnLabel("驗證")
                set_tip("60天內只能更動1次。");
                break;
        }
        setInProp(true);
        const handleResize = () => {
            adjustButtonPosition();
        };
        const viewport = window.visualViewport;
        if (viewport) {
            viewport.addEventListener('resize', adjustButtonPosition);
            viewport.addEventListener('scroll', adjustButtonPosition);
        } else {
            window.addEventListener('resize', handleResize);
        }
        adjustButtonPosition();
        return () => {
            if (viewport) {
                viewport.removeEventListener('resize', adjustButtonPosition);
                viewport.removeEventListener('scroll', adjustButtonPosition);
            } else {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, []);
    function updateText(value) {
        switch (arg.type) {
            case "name":
                // 不能输入数字与符号，只允许字母和空格
                if (value === "" || /^[\p{L} ]+$/u.test(value)) {
                    set_text(value);
                }
                break;
            case "ID":
                // 只能输入数字、英文、`.` 和 `_`
                if (value === "" || (/^[A-Za-z0-9._]+$/.test(value))) {
                    set_text(value);
                }
                break;
            case "mail":
                    set_text(value);
                break;
        }
    }
    function btnDisabled(){
        switch (arg.type) {
            case "name":
                return (text.length===0);
                break;
            case "ID":
                return (text.length===0);
                break;
            case "mail":
                return !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text));
                break;
        }
    }
    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "EditProfile1"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                        </div>
                        <div className={styleUi.view}>
                            <YStyled.Col style={{ height: "100%", justifyContent: "space-between" }}>
                                <YStyled.Col>
                                    <YStyled.Row style={{ padding: "0 .4rem", margin: "1.6rem 0 .6rem 0" }}>
                                        <YStyled.Span color="#3C3C43" fontWeight={400} size={13} >{label}</YStyled.Span>
                                        {(limitLen !== 50) &&
                                            <YStyled.Span color="#8A8A8E" fontWeight={400} size={13} >{`${text.length}/${limitLen}`}</YStyled.Span>
                                        }
                                    </YStyled.Row>
                                    <YStyled.Label style={{ width: "100%", marginTop: ".5rem", paddingRight: "0px" }}>
                                        <YStyled.Row>
                                            <YStyled.Input value={text} maxLength={limitLen} onChange={e => {
                                                updateText(e.target.value);
                                            }}></YStyled.Input>
                                            <img src="./assets/ui/clear.svg" style={{ paddingRight: ".8rem", width: "1.2rem", cursor: "pointer" }} onClick={e => {
                                                set_text("");
                                            }} />
                                        </YStyled.Row>
                                    </YStyled.Label>
                                    <YStyled.Span fontWeight={400} size={13} style={{ opacity: "0.8", alignSelf: "flex-start", marginTop: "1rem" }}>{tip}</YStyled.Span>
                                </YStyled.Col>
                                <YStyled.BTN3 disabled={btnDisabled()} normalBg="#F2CE3E" disableBg="#CCCCCC" disableColor="#ffffff" hoverBg="F8F8F8" normalColor="black" className={styleUi.sumbitBtn} style={{ bottom: `${h + 40}px` }} id="sumbitBtn">
                                    <YStyled.Span size={17} >{btnLabel}</YStyled.Span>
                                </YStyled.BTN3>
                            </YStyled.Col>
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(EditProfile1);

